export const ALL_USERS_GROUP_ID = 'all';
export const ADMINS_GROUP_ID = 'Admins';
